export const insightsStrings = {
  title: 'Insights',
  shareRecap: {
    action: 'Share recap',
    title: 'Share recap',
    period: 'Period',
    layout: 'Layout',
    storyEyebrow: 'MY HOBBY STORY',
    hobbyMix: 'Hobby mix',
    hobbyMoment: 'This story',
    hobbyFocus: 'Hobby focus',
    milestone: 'Milestone',
    addPhoto: 'Add photo',
    changePhoto: 'Change photo',
    removePhoto: 'Remove photo',
    messageLabel: 'Message on your recap',
    messageHelper: 'Appears below the title.',
    editMessage: 'Edit recap message',
    useSuggestedMessage: 'Use suggested message',
    doneEditing: 'Done',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    post: 'Post',
    story: 'Story',
    sharedDetails: 'Shared details',
    sharedDetailsSummary: 'Choose what appears in this recap.',
    saveDefaults: 'Save as my default',
    defaultsSaved: 'Insight Recap defaults saved.',
    share: 'Share',
    download: 'Download',
    downloadImage: 'Download image',
    preparing: 'Preparing recap...',
    footer: 'Explore your hobbies with Hobtalk',
    website: 'hobtalk.com',
  },
  dates: {
    noActivity: 'No activity yet',
    recently: 'Recently',
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: (count) => `${count} days ago`,
  },
  loading: {
    title: 'Reading your patterns.',
    detail: 'Loading your hobby activity, favorites, and recent updates.',
  },
  error: {
    title: 'We could not load your insights.',
    detail: 'Your hobbies are still available. Try again, or open the home feed.',
    retry: 'Try again',
    openHome: 'Open home',
  },
  empty: {
    title: 'Your patterns will appear here.',
    detail: 'Add your first recipe, movie, book, trip, show, workout, or hike and this page will start turning activity into useful recaps.',
    primaryAction: 'Choose a hobby',
    secondaryAction: 'Add activity',
    summaryTitle: 'Nothing to summarize yet',
    summaryDetail: 'Insights v1 uses your saved items, favorites, weekly activity, and fitness streak to build a simple cross-hobby recap.',
  },
  hero: {
    title: 'Your hobbies at a glance.',
    detail: 'Weekly activity, favorites, recent updates, and cross-hobby patterns from the things you have saved.',
  },
  windows: {
    labels: {
      sevenDays: '7 days',
      thirtyDays: '30 days',
      ninetyDays: '90 days',
      year: 'Year',
      all: 'All',
      fallback: 'this period',
    },
    selectorLabel: 'Insights time window',
  },
  recap: {
    eyebrow: (windowLabel) => `${windowLabel} recap`,
    defaultTitle: 'Your patterns will appear here.',
    overview: {
      updates: 'Updates',
      activeHobbies: 'Active hobbies',
      activeDays: 'Active days',
      favorites: 'Favorites',
      savedIn: (windowLabel) => `Saved in ${windowLabel}`,
      ledTheWay: (hobby) => `${hobby} led the way`,
      startSmall: 'Start with one small entry',
      activeDaysNote: 'Days with hobby activity',
      favoritesNote: 'Things worth revisiting',
    },
  },
  momentum: {
    eyebrow: 'Momentum',
    byHobbyTitle: 'Momentum by hobby',
    empty: 'Add activity across hobbies to see what is picking up, steady, or quieter.',
    pickingUp: 'Your hobby rhythm is picking up.',
    quieter: 'A quieter stretch is still part of the rhythm.',
    steady: 'You are holding a steady pace.',
    thisPeriod: 'This period',
    updates: (windowLabel) => `${windowLabel} updates`,
    compared: 'Compared with before',
    previous: (count) => `${count} in the previous period`,
    mostConsistent: 'Most consistent',
    mostConsistentNote: 'The hobby showing up most often',
    activeDays: 'Active days',
    activeDaysNote: 'Days where you saved or updated something',
  },
  attention: {
    eyebrow: 'Next',
    title: 'Useful next steps',
    empty: 'Add a few entries and Hobtalk will suggest useful follow-ups here.',
    continue: (title) => `Continue ${title}`,
    revisit: (hobby) => `Revisit ${hobby}`,
    recentBody: (hobby) => `${hobby} has recent activity. Open it when you want to keep going.`,
    readyBody: (hobby) => `${hobby} is ready whenever you want to add the next small update.`,
    giveUpdate: (hobby) => `Give ${hobby} a small update`,
    quieterBody: (hobby) => `${hobby} was quieter than the previous period. One small entry is enough to restart momentum.`,
    keepMomentum: (hobby) => `Keep the ${hobby} momentum`,
    strongerBody: (delta) => `${delta} compared with the previous period. This is a good place to continue.`,
  },
  charts: {
    mixEyebrow: 'Mix',
    mixTitle: 'Hobby mix',
    mixEmpty: 'Add activity across hobbies to see your mix.',
    patternEyebrow: 'Pattern',
    empty: 'Keep adding entries and this pattern will fill in.',
    pulseLess: 'Less',
    pulseMore: 'More',
    patternsEyebrow: 'Visuals',
    patternsTitle: 'Patterns',
  },
  highlights: {
    eyebrow: 'Highlights',
    title: 'Hobby highlights',
    active: (count) => `${count} active`,
    saved: (count) => `${count} saved ${count === 1 ? 'entry' : 'entries'}`,
    latest: (title) => `Latest: ${title}`,
    openHobby: 'Open hobby',
    previousDelta: (delta) => `${delta} vs previous`,
  },
  patterns: {
    eyebrow: 'Patterns',
    title: 'What you are learning',
    empty: 'Add a little more activity and Hobtalk will start finding patterns across your hobbies.',
  },
  breakdown: {
    eyebrow: 'Hobbies',
    title: 'Activity breakdown',
    active: (count) => `${count} active`,
    latest: (title) => `Latest: ${title}`,
    noEntries: 'No entries yet',
    thisWeek: (count) => `${count} this week`,
  },
  deepDives: {
    eyebrow: 'Deep dives',
    title: 'Deep dives',
    detailEyebrow: 'Hobby insights',
    atAGlance: 'At a glance',
    consistency: 'Consistency',
    patterns: 'Your patterns',
    standouts: 'Standouts',
    updates: (count) => `${count} ${count === 1 ? 'update' : 'updates'} in this window`,
    open: (hobby) => `Open ${hobby}`,
  },
  fitness: {
    weeklyProgress: 'This week',
    routineProgress: (completed, scheduled) => `${completed} of ${scheduled} workouts completed`,
    noRoutine: 'Create a routine to see weekly adherence and a clear next workout.',
    adherenceTrend: 'Routine adherence',
    adherenceTrendDetail: 'Completed routine days across recent weeks',
    minutesTrend: 'Workout minutes',
    minutesTrendDetail: 'Completed workout time across recent weeks',
    nextWorkout: 'Next workout',
    startNext: 'Open next workout',
    openFitness: 'Open Fitness',
    remaining: (count) => `${count} remaining this week`,
  },
  recent: {
    eyebrow: 'Recent',
    title: 'Latest updates',
    emptyTitle: 'No recent activity yet',
    emptyDetail: 'Your latest saves and updates will appear here.',
  },
  next: {
    eyebrow: 'Next',
    title: 'Useful ideas',
    count: (count) => `${count} ${count === 1 ? 'idea' : 'ideas'}`,
    emptyTitle: 'No ideas right now',
    emptyDetail: 'You are caught up. As you add more activity, Hobtalk will surface useful follow-ups here.',
  },
  hiking: {
    eyebrow: 'Hiking',
    title: 'Trail recap',
    empty: 'Add hikes to see distance, elevation, trip links, and planning progress here.',
    total: 'Total hikes',
    completed: 'Completed',
    planned: 'Planned',
    linked: 'Linked to trips',
    distance: 'Distance',
    elevation: 'Elevation gain',
    terrain: 'Top terrain',
    difficulty: 'Top difficulty',
  },
  stats: {
    totalEntries: { label: 'Total entries', note: 'Saved across all hobbies' },
    activeHobbies: { label: 'Active hobbies', note: 'Hobbies with at least one entry' },
    thisWeek: { label: 'This week', note: 'New or updated this week' },
    favorites: { label: 'Favorites', note: 'Items worth revisiting' },
    fitnessStreak: { label: 'Fitness streak', note: 'Current workout-day streak' },
    zeroDays: '0 days',
  },
};
